import {
    feathersClient,
    usersChatListService,
    messagesService,
    messageTotalsService,
    messagesTypeService
} from '../feathers-client'
import debounce from 'lodash/debounce'

export default {
    state: () => ({
        nodeChatMessages: [],
        nodeChatUsersChats: [],
        nodeChatMessageTotals: [],
        nodeChatShown: false,
        nodeChatUnreadMessages: false,
        token: null,
        authenticationClient: null,
        feathersClient: feathersClient,
        currentUser: null,
        nodeChatCurrentChatType: null,
        nodeChatCurrentChatTypeId: null,
    }),
    data() {
        return {
            pageCheck: 0
        }
    },
    getters: {
        nodeChatMessages: s => s.nodeChatMessages,
        nodeChatShown: s => s.nodeChatShown,
        nodeChatUnreadMessages: s => s.nodeChatUnreadMessages,
        token: s => s.token,
        authenticationClient: s => s.authenticationClient,
        feathersClient: s => s.feathersClient,
        currentUser: s => s.currentUser,
        nodeChatMessageTotals: s => s.nodeChatMessageTotals,
        nodeChatCurrentChatType: s => s.nodeChatCurrentChatType,
        nodeChatCurrentChatTypeId: s => s.nodeChatCurrentChatTypeId,
    },


    mutations: {
        toggleChat(state) {
            state.nodeChatShown = !state.nodeChatShown
            localStorage.setItem('nova.mainMenu.open', state.nodeChatShown)
        },
        setAuthenticationClient(state, client){
            state.authenticationClient = client
        },        setToken(state, token){
            state.token = token
        },
        setUsersChats(state, usersChats){
            state.nodeChatUsersChats = usersChats
        },
        setCurrentUser(state, user){
            state.currentUser = user
        },
        setMessages(state, messages){
            if (this.pageCheck != 1) state.nodeChatMessages.push(...messages)
            else state.nodeChatMessages = messages
        },
        setMessageTotals(state, totals){
            state.nodeChatMessageTotals = totals
        },
        setCurrentTypeItem(state, {type, typeId}){
            state.nodeChatCurrentChatType = type
            state.nodeChatCurrentChatTypeId = typeId
        }
    },

    watch: {
        token(newValue){

        },
        nodeChatCurrentChatTypeId() {
            this.nodeChatMessages = []
        }
    },

    actions: {
        nodeChatInit({dispatch}){
            dispatch('getToken')
            messagesTypeService.on('created', message => {
                dispatch('onNewMessage', message);
                dispatch('fetchMessageTotals')
            })
            messagesTypeService.on('removed', message => {
                dispatch('onRemoveMessage', message);
                dispatch('fetchMessageTotals')
            })
            messagesService.on('patched', () => {
                dispatch('fetchMessageTotals')
                console.log('fetchMessageTotals');
            })
        },
        getToken({dispatch, commit}) {
            Nova.request(`/nova-api/node-chat/token`)
                .then( response => {
                    commit('setToken', response.data.token)
                    dispatch('nodeChatAuth')
                })

        },
        nodeChatAuth({dispatch,state}){
            state.feathersClient.authenticate({
                strategy: 'jwt',
                accessToken: state.token
            }).then(() => {
                //dispatch('fetchMessageTotals')
            }).catch( e => {
                console.error('Authentication error', e);
            })
        },
        fetchUserChats({state, commit}){
            usersChatListService
                .find({limit: 20})
                .then(response => {
                    commit('setUsersChats', response.data)
                })
            messagesService
                .find({limit: 20})
                .then(response => {
                    commit('setMessages', response.data)
                })

            // commit('setUsersChats', usersChats)
        },
        fetchTypeIdMessages({commit}, {type, typeId, params, page}){
            this.pageCheck = page;
            const query = {...{"$limit": 150, "$skip": (page - 1) * 150}, ...params}
            feathersClient.service(`messages/${type}/${typeId}`)
                .find({query})
                .then(response => {
                    commit('setMessages', response.data)
                })
        },
        fetchMessageTotals({commit}){
            // messageTotalsService
            //     .find({})
            //     .then(data => {
            //         commit('setMessageTotals', data)
            //     })
        },
        onNewMessage({state, commit}, message){
            if(message.type !== state.nodeChatCurrentChatType
                || message.typeId !== state.nodeChatCurrentChatTypeId) return

            let messages = state.nodeChatMessages
            if(message.replyMessageId === null) {
                messages.unshift(message)
            } else {
                //рекурсивный поиск сообщения
                (function func(messages){
                    for(let elem of messages){
                        if(elem.id == message.replyMessageId){
                            if(typeof elem.replies === 'undefined') elem.replies = []
                            if(typeof elem.replies.data === 'undefined') elem.replies.data = []
                            elem.replies.data.unshift(message)
                        } else if(elem.replies && elem.replies.data){
                            func(elem.replies.data)
                        }
                    }
                })(messages)
            }

            commit('setMessages', messages);
        },
        onRemoveMessage({state, commit}, message){
            if(message.type !== state.nodeChatCurrentChatType
                || message.typeId !== state.nodeChatCurrentChatTypeId) return

            let messages = state.nodeChatMessages;

            (function func(arr){
                arr.forEach((elem, i) => {
                    if(elem.id == message.id){
                        arr.splice(i, 1)
                    } else if(elem.replies && elem.replies.data){
                        func(elem.replies.data)
                    }
                })
            })(messages)

            commit('setMessages', messages);
        },
        selectCurrentTypeItem({commit}, {type, typeId}){
            commit('setCurrentTypeItem', {
                type: type,
                typeId: typeId
            })
        }
    }
}
